import React from 'react';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cargar_PuntosFacturacion, seleccionar_PuntoFacturacion } from '../../actions/ventas/act_ven02';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';

class PuntoFacturacion extends React.Component{
    constructor(props) {
        super(props);
        this.cambiarPuntoFacturacion = this.cambiarPuntoFacturacion.bind(this);
    }

    componentDidMount(){
        let puntoFacturacionDefault;
        
        if (this.props.puntosFacturacion.length===0){
            let empresaId = getItemDatosSesion('empresaActual')?JSON.parse(getItemDatosSesion('empresaActual')).Id:'';
            let usuario = getItemDatosSesion('usuario');

            this.props.cargar_PuntosFacturacion(empresaId, usuario, 'E')
            .then(()=>{                
                for(let i=0; i<this.props.puntosFacturacion.length; i++){
                    if (this.props.puntosFacturacion[i].EsDefault==='S'){
                        puntoFacturacionDefault = this.props.puntosFacturacion[i].Codigo;
                        break;
                    }
                }
                this.props.seleccionar_PuntoFacturacion(puntoFacturacionDefault);
            });
        }else{
            for(let i=0; i<this.props.puntosFacturacion.length; i++){
                if (this.props.puntosFacturacion[i].EsDefault==='S'){
                    puntoFacturacionDefault = this.props.puntosFacturacion[i].Codigo;
                    break;
                }
            }
            this.props.seleccionar_PuntoFacturacion(puntoFacturacionDefault);
        }
    }

    cambiarPuntoFacturacion(value){        
        let puntoFacturacionSel = null;
        if (value !== null){
            puntoFacturacionSel = value.value;
        }
        this.props.seleccionar_PuntoFacturacion(puntoFacturacionSel);
    }
    
    render(){
        let ptosFacturacion = this.props.puntosFacturacion.map(item => ({value: item.Codigo, label: `[${item.Establecimiento} - ${item.PtoEmision}]` }));

        return(
            <div>
                <ReactSelect disabled={this.props.disabled} options={ ptosFacturacion } value={this.props.puntoFacturacionSel} func_onChange={(value)=>{ this.cambiarPuntoFacturacion(value)}}/>
            </div>
        )
    }
}

const mapStateToProps = ((state) => {
    return { puntosFacturacion: state.ventas.puntosFact, puntoFacturacionSel: state.ventas.ptoFacturacionSel }
  });
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ cargar_PuntosFacturacion, seleccionar_PuntoFacturacion }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(PuntoFacturacion);